module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas Kiernan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Thomas Kiernan was an author and editor of twenty-five books. He graduated from Notre Dame and completed graduate work at Columbia University in philosophy. Kiernan was a senior editor at Philosophical Library, and is the author of "), _c('I', [_vm._v("Arafat")]), _vm._v(", "), _c('I', [_vm._v("The Man and the Myth")]), _vm._v("; "), _c('I', [_vm._v("A Treasury of Albert Schweitzer")]), _vm._v("; "), _c('I', [_vm._v("Who’s Who in the History of Philosophy")]), _vm._v("; "), _c('I', [_vm._v("The Intricate Music: A Biography of John Steinbeck")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/i3Rpyq/tc-custom/9781504055048.jpg?1708746329678",
      "alt": "This image is the cover for the book Aristotle Dictionary"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Aristotle Dictionary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At long last, a comprehensive tool in English for a better understanding of the most basic terms in Aristotle’s philosophy. Interested readers, students, and scholars of philosophy and of the general intellectual background of Western culture need no longer be handicapped by a lack of knowledge of Greek and Latin. A careful comparison of the original Greek, Medieval, and Renaissance Latin translations and a reappraisal of English usage make "), _c('i', [_vm._v("Aristotle Dictionary")]), _vm._v(" a definitive source for the precise grasp of what has been the historical Aristotle as far as the documents permit one to judge."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A lengthy introduction by Professor Theodore E. James presents an analysis of the major works of Aristotle."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0